export default __webpack_public_path__ + "static/media/WaveGold-Grafik.952f2630.png";